import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataSouhait } from '../../data/DataSouhait';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField';
import { FicheContact } from '../Fiche/FicheContact/FicheContact';
import { FicheSouhaitMaisonIndividuelle } from '../Fiche/FicheSouhait_MaisonIndividuelle';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
***************************************************************
 PROPS:

    //*********************************************************
    //Appel depuis contact
    //pas de bouton d'édition du contact
    //CSS spécifique
    //idContact chargé dans la fiche contact et la fiche souhait est égale à la props passée en paramètre

    
    appelDepuisContact
    idContact
    //*********************************************************


    //*********************************************************
    //Appel depuis la réservation
    //paramètres en entrée : 
    //  liste d'IdContact et d'IdSouhait => chargement du tableau avec ces IDs
    //  Sélection d'une ligne et faire un retour de l'IdContact et l'IdSouhait sélectionnés
    //pas de zone de commandBar
    //CSS spécifique
    //Pas d'affichage des liens vers les souhaits, dénonciations et historique


    appelDepuisReservation
    selectionIdContactIdSouhait => objet json sous la forme ci-dessous:
           let objIdContactIdSouhait = [{ "idContact": 34, "idSouhait": 2 }, { "idContact": 3174, "idSouhait": 2 }]
    //*********************************************************


    //mode sélection de souhait
    onSelectionSouhait => méthode utilisée par le parent pour récupérer l'IdContact et l'IdSouhait du souhait sélectionné
    modeSelectionDeSouhait => SelectionMode.none, SelectionMode.single, SelectionMode.multiple

    ***************************************************************
*/

var objetState = {
    items: [],
    idContact: 0,
    idSouhait: 0,

    enCoursDeTraitement: false,
    onAffichePanelContact: false,
    onAffichePanelSouhait: false,
    onAffichePanelFiltre: false,
    onAfficheDialogSuppressionSouhait: false,

    selectionIdContactIdSouhait: [],

    peutCreerDesSouhaits: false,

    pageIndex: 1,
    facteurNbreEnregistrement: 500,
    tri: "",

    hideMessageBarWarning: true,
    hideMessageBarError: true,
    hideMessageBarFiltres: true,
    warningMessage: '',
    errorMessage: '',
    messageMessageBarFiltres: '',

    recherche: '',

    filtreNomContact: '',
    filtreDateR2: null,

    nombreMinSlider: 100,
    nombreMaxSlider: 10000,
    stepSlider: 500
};

export class DetailsListSouhaitMaisonIndividuelle extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListSouhaitMaisonIndividuelleWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListSouhaitMaisonIndividuelleWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _selection;

    _creationContent() {
        const { items } = this.state;

        return (
            <DetailsList
                setKey="items"
                items={items}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
                selectionMode={SelectionMode.single}
                columns={this.columns}
                selection={this._selection}
                selectionPreservedOnEmptyClick={true}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderItemColumn={this._onRenderItemColumn}
            />
        );
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this._getSelectionDetails() })
        });

        this.state = objetState;

        //#region chargement des columns
        let columnsTemp = [];

        columnsTemp.push({
            key: 'nomContact',
            name: 'Contact',
            ariaLabel: 'Contact',
            fieldName: 'nomContact',
            minWidth: 100,
            maxWidth: 300,
            isResizable: true,
            onRender: (item) => {
                let nomContact = item.nomContact;
                return <span title={nomContact}>{nomContact}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_TypeLogementActuel',
            name: 'Logement actuel',
            ariaLabel: 'Logement actuel',
            fieldName: 'LogementActuel',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let logementActuel = (item.mI_TypeLogementActuel !== null && item.mI_TypeLogementActuel !== undefined ? item.mI_TypeLogementActuel : '') + (item.mI_TypeResidence !== null && item.mI_TypeResidence !== undefined ? ' (Rés. ' + item.mI_TypeResidence + ')' : '');
                return <span title={logementActuel}>{logementActuel}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_DateEntreeSouhaitee',
            name: 'Date emménagement souhaitée',
            ariaLabel: 'Date emménagement souhaitée',
            fieldName: 'DateEntreeSouhaitee',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let dateEntreeSouhaitee = Scriba.date().stringDateFormatCourt(item.mI_DateEntreeSouhaitee);
                return <span className='ms-hiddenMdDown' title={dateEntreeSouhaitee}>{dateEntreeSouhaitee}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_DatePrevisionnelleDecision',
            name: 'Date prise décision',
            ariaLabel: 'Date prise décision',
            fieldName: 'DatePrevisionnelleDecision',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let datePrevisionnelleDecision = Scriba.date().stringDateFormatCourt(item.mI_DatePrevisionnelleDecision);
                return <span className='ms-hiddenMdDown' title={datePrevisionnelleDecision}>{datePrevisionnelleDecision}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_DateRdv2',
            name: 'Date R2',
            ariaLabel: 'Date R2',
            fieldName: 'DateRdv2',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                let dateRdv2 = Scriba.date().stringDateFormatCourt(item.mI_DateRdv2);
                return <span className='ms-hiddenMdDown' title={dateRdv2}>{dateRdv2}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_NbPieces',
            name: 'Nb pièces souhaitées',
            ariaLabel: 'Nb pièces souhaitées',
            fieldName: 'NbPieces',
            minWidth: 50,
            maxWidth: 80,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let nbPieces = item.mI_NbPieces;
                return <span title={nbPieces}>{nbPieces}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_AvecEtage',
            name: 'Etage ?',
            ariaLabel: 'Etage ?',
            fieldName: 'AvecEtage',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let avecEtage = item.mI_AvecEtage;
                return <span>{avecEtage ? 'Oui' : 'Non'}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_AvecSousSol',
            name: 'Sous-sol ?',
            ariaLabel: 'Sous-sol ?',
            fieldName: 'AvecSousSol',
            minWidth: 80,
            maxWidth: 80,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let avecSousSol = item.mI_AvecSousSol;
                return <span>{avecSousSol ? 'Oui' : 'Non'}</span>;
            }
        });
        columnsTemp.push({
            key: 'mI_PossedeTerrain',
            name: 'Possède un terrain ?',
            ariaLabel: 'Possède un terrain ?',
            fieldName: 'PossedeTerrain',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                let possedeTerrain = item.mI_PossedeTerrain;
                return <span>{possedeTerrain ? 'Oui' : 'Non'}</span>;
            }
        });
        columnsTemp.push({
            key: 'creerPar',
            name: 'Commercialisateur',
            ariaLabel: 'Commercialisateur',
            fieldName: 'CreerPar',
            minWidth: 100,
            maxWidth: 300,
            isResizable: true,
            onRender: (item) => {
                let creerPar = item.creerPar;
                return <span title={creerPar}>{creerPar}</span>;
            }
        });

        if (!this.props.appelDepuisContact) {
            columnsTemp.push({
                key: 'EditionContact',
                name: '',
                ariaLabel: 'Modifier le contact',
                fieldName: 'EditionContact',
                minWidth: 20,
                maxWidth: 20,
                isResizable: true,
                onRender: (item) => {
                    if (item.peutEditerContact) {
                        return <IconButton
                            iconProps={{ iconName: 'EditContact' }}
                            title="Modifier le contact"
                            ariaLabel="Edition"
                            onClick={() => this._onAffichagePanelContact(item.idContact)}
                        />;
                    }
                    else {
                        return null;
                    }
                }
            });
        }

        columnsTemp.push({
            key: 'EditionSouhait',
            name: '',
            ariaLabel: 'Modifier le souhait',
            fieldName: 'EditionSouhait',
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.peutModifier) {
                    return <IconButton
                        iconProps={{ iconName: 'Edit' }}
                        title="Modifier le souhait"
                        ariaLabel="Edition"
                        onClick={() => this._onAffichagePanelSouhait(item.idContact, item.idSouhait)}
                    />;
                }
                else {
                    return null;
                }
            }
        });
        columnsTemp.push({
            key: 'delete',
            name: 'Delete',
            ariaLabel: 'Supprimer le souhait',
            fieldName: 'delete',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.peutSupprimer) {
                    return <IconButton
                        iconProps={{ iconName: 'Delete' }}
                        title="Supprimer le souhait"
                        ariaLabel="Suppression"
                        onClick={() => this._onAffichageDialogSuppressionSouhait(item.idContact, item.idSouhait)}
                    />;
                }
                else {
                    return null;
                }
            }
        });

        this.columns = columnsTemp;
        //#endregion
    }

    _getItems = () => {
        let tableauBoutons = [
            {
                key: 'search',
                onRender: () => <SearchBox
                    placeholder="Recherche rapide"
                    className="searchBox"
                    onSearch={value => this._onSearchBox(value)}
                    onClear={(e) => this._onSearchBox('')}
                //onBlur={(e) => this._onBlurSearchBox(e.target.value)}
                />
            },
        ];

        if (this._selection.getSelectedCount() > 0 | (this.props.idContact > 0)) {
            let idContact = 0;
            if (this.props.idContact > 0) {
                idContact = this.props.idContact;
            }
            else {
                this._selection.getSelection().map(function (souhait) {
                    idContact = souhait.idContact;
                });
            }

            if (this.state.peutCreerDesSouhaits) {

                let boutonNouveauSouhait = {
                    key: 'nouveauSouhait',
                    name: 'Nouveau souhait',
                    iconProps: {
                        iconName: 'Add'
                    },
                    onClick: (() => this._onAffichagePanelSouhait(idContact, 0))
                }

                tableauBoutons.push(boutonNouveauSouhait);
            }
        }

        return tableauBoutons;
    }

    _getFarItems = () => {
        //if (this.props.appelDepuisReservation) {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
        //}
        //else {
        //    return null;
        //}
    }

    _onInit() {
        this.setState(objetState);
    }

    _onSuppressionSouhait = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression du souhait en cours'
        });

        var onSuppressionSouhait = DataSouhait._onSuppressionSouhait(this.state.idContact, this.state.idSouhait);

        onSuppressionSouhait
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    // MG - 23/02/2022 - retirer le contact supprimé du state pour rechargement
                    this.setState(prevState =>
                    ({
                        items: prevState.items.filter(item => item.idContact !== this.state.idContact && item.idSouhait !== this.state.idSouhait),
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarError: true,
                        errorMessage: '',

                        onAfficheDialogSuppressionSouhait: false,

                        idContact: 0,
                        idSouhait: 0

                    }), this._chargementDonnees);
                }
                else {
                    let stateTemp = {};
                    stateTemp.onAfficheDialogSuppressionSouhait = false;
                    stateTemp.idContact = 0;
                    stateTemp.idSouhait = 0;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des souhaits en cours'
        });

        //si this.props.selectionIdContactIdSouhait est renseigné => on souhaite récupérer les souhaits définis par ces clefs
        //si idContact est renseigné => on souhaite récupérer les souhaits du contact
        //si non on récupère tous les souhaits

        let chargementDesSouhaitsMaisonIndividuelle = DataSouhait._chargementDesSouhaitsMaisonIndividuelle(this.props.idContact, this.state.facteurNbreEnregistrement, this.state.pageIndex, this.state.recherche, this.state.tri, this.props.selectionIdContactIdSouhait, this.props.appelDepuisReservation, this.state.filtreNomContact, this.state.filtreDateR2);

        chargementDesSouhaitsMaisonIndividuelle
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let new_Items = [];
                    let retourData = responseFetch.reponseAPIobjet;
                    //let listeItem = retourData[0];
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (retourData[0] !== null ? retourData[0] : []);

                    let peutCreerDesSouhaits = retourData[1];

                    if (this.state.pageIndex === 1) {
                        new_Items = listeItem;
                    }
                    else {
                        new_Items = this.state.items;
                        new_Items = new_Items.concat(listeItem);
                    }

                    this.setState({
                        items: new_Items,

                        peutCreerDesSouhaits: peutCreerDesSouhaits,

                        enCoursDeTraitement: false,
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage,
                        hideMessageBarFiltres: (responseFetch.messageInfo === "" || responseFetch.messageInfo === null),
                        messageMessageBarFiltres: responseFetch.messageInfo
                    });
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];
                    stateTemp.peutCreerDesSouhaits = false;

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    }

    _getSelectionDetails() {
        if (this.props.modeSelectionDeSouhait !== undefined & this.props.modeSelectionDeSouhait !== SelectionMode.none) {
            if (this._selection.getSelectedCount() > 0) {
                this.setState({
                    selectionIdContactIdSouhait: []
                });

                this.props.onSelectionSouhait(this._selection);
            }
            else {
                this.props.onSelectionSouhait(null);

                this.setState({
                    selectionIdContactIdSouhait: []
                });
            }
        }
    }

    _onAffichagePanelContact = (idContact) => {
        this.setState({
            onAffichePanelContact: true,
            idContact: idContact
        });
    }

    _onAffichagePanelSouhait = (idContact, idSouhait) => {
        this.setState({
            onAffichePanelSouhait: true,
            idContact: idContact,
            idSouhait: idSouhait
        });
    }

    _onAffichePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: true });
    };

    _onAffichageDialogSuppressionSouhait = (idContact, idSouhait) => {
        this.setState({
            onAfficheDialogSuppressionSouhait: true,

            idContact: idContact,
            idSouhait: idSouhait
        });
    }

    _onCachePanelContact = () => {
        this.setState({
            onAffichePanelContact: false,
            idContact: 0
        });
    };

    _onCachePanelContactEtRechargementDesDonnees = () => {
        if (this.state.onAffichePanelContact) {
            this.setState({
                onAffichePanelContact: false,
                idContact: 0
            });

            this._chargementDonnees();
        }
    };

    _onCachePanelSouhait = () => {
        this.setState({
            onAffichePanelSouhait: false,
            idContact: 0,
            idSouhait: 0
        });
    };

    _onCachePanelSouhaitEtRechargementDesDonnees = () => {
        if (this.state.onAffichePanelSouhait) {
            this.setState({
                onAffichePanelSouhait: false,
                idContact: 0,
                idSouhait: 0
            });

            this._chargementDonnees();
        }
    };

    _onCachePanelFiltre = () => {
        this.setState({ onAffichePanelFiltre: false });
    };

    _onCacheDialogSuppressionSouhait = () => {
        this.setState({
            onAfficheDialogSuppressionSouhait: false,

            idContact: 0,
            idSouhait: 0
        });
    }

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            { pageIndex: 1 },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            pageIndex: 1,
            facteurNbreEnregistrement: 500
        });
    }

    _onSelectDate(value, champ) {
        var valeurDate = Scriba.date().getChaineISOFromDate(value, true);
        this.setState({ [champ]: valeurDate });
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    };

    _incrementeNbreEnregistrementEtChargementDonnees() {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    }

    //_modificationNbreEnregistrementParPageETrepositionnementDuScrollEnHautDeLaPage(value) {
    //    this.setState({
    //        facteurNbreEnregistrement: value,
    //        pageIndex: 1
    //    });
    //}

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _reinitFiltre = () => {
        this.setState({
            filtreNomContact: '',
            filtreDateR2: null,

            pageIndex: 1,
            facteurNbreEnregistrement: 500
        });
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    };

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    //*************************************************************
    //    //ne marche pas
    //    //if(this.props.onRecharge === true)
    //    //    this._chargementDonnees();
    //    //*************************************************************
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this.setState(
    //            { pageIndex: 1 },
    //            this._chargementDonnees
    //        );
    //    }

    //    if (this.props.selectionIdContactIdSouhait != null & this.props.selectionIdContactIdSouhait !== this.state.selectionIdContactIdSouhait) {
    //        this.setState({
    //            pageIndex: 1,
    //            selectionIdContactIdSouhait: this.props.selectionIdContactIdSouhait
    //        }, this._chargementDonnees);
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this.setState({ pageIndex: 1 }, this._chargementDonnees);

        if (this.props.selectionIdContactIdSouhait != null & this.props.selectionIdContactIdSouhait !== this.state.selectionIdContactIdSouhait) {
            this.setState({
                pageIndex: 1,
                selectionIdContactIdSouhait: this.props.selectionIdContactIdSouhait
            }, this._chargementDonnees);
        }
    };

    componentWillUnmount() {
        //document.removeEventListener('scroll', this._evenementScroll);
    }

    render = () => {

        //<Slider
        //    label="Nombre d'enregistrements/page"
        //    min={this.state.nombreMinSlider}
        //    max={this.state.nombreMaxSlider}
        //    step={this.state.stepSlider}
        //    defaultValue={this.state.facteurNbreEnregistrement}
        //    showValue={true}
        //    onChange={(value) => this._modificationNbreEnregistrementParPageETrepositionnementDuScrollEnHautDeLaPage(value)}
        ///>

        const content = this._creationContent();
        const idContact = (this.props.appelDepuisContact ? this.props.idContact : this.state.idContact);

        //**************************************************************************************************************
        //si on arrive de la réservation on n'affiche pas les liens vers les souhaits, dénonciations et historique
        let ficheContactPasDAccesAuxSouhaits = this.props.appelDepuisReservation;
        let ficheContactPasDAccesAuxSouhaitsMaisonIndividuelle = this.props.appelDepuisReservation;
        let ficheContactPasDAccesAuxDenonciations = this.props.appelDepuisReservation;
        let ficheContactPasDAccesAHistorique = this.props.appelDepuisReservation;
        //**************************************************************************************************************

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                {this.props.appelDepuisReservation ? null :
                    <CommandBar
                        items={this._getItems()}
                        overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                        farItems={this._getFarItems()}
                        ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                    />
                }

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.props.appelDepuisReservation || this.props.appelDepuisContact ? content :
                    <div className="position-relative h-100">
                        <ScrollablePane
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            onScroll={this._onScroll}
                        >
                            {content}
                        </ScrollablePane>
                    </div>
                }
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <EUITextField
                                label="Contact"
                                maxLength={MaxLengths.contact.nom}
                                onChange={(event, newValue) => this.setState({ filtreNomContact: newValue })}
                                placeholder="Saisir le nom"
                                value={this.state.filtreNomContact}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <EUIDatePicker
                                label="Date R2"
                                onSelectDate={date => this.setState({ filtreDateR2: Scriba.date().getChaineISOFromDate(date, true) })}
                                value={this.state.filtreDateR2}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <FicheContact
                idContact={idContact}
                isOpen={this.state.onAffichePanelContact}
                onAnnuleFiche={() => this._onCachePanelContactEtRechargementDesDonnees()}
                onEnregistrementFiche={() => this._onCachePanelContactEtRechargementDesDonnees()} // Jamais appelée ? Inutile ?
                pasDAccesAHistorique={ficheContactPasDAccesAHistorique}
                pasDAccesAuxDenonciations={ficheContactPasDAccesAuxDenonciations}
                pasDAccesAuxSouhaits={ficheContactPasDAccesAuxSouhaits}
                pasDAccesAuxSouhaitsMaisonIndividuelle={ficheContactPasDAccesAuxSouhaitsMaisonIndividuelle}

            //onPeutChargerLeComposant={this.state.onAffichePanelContact}
            />
            <FicheSouhaitMaisonIndividuelle
                onAffichePanelSouhait={this.state.onAffichePanelSouhait}
                idContact={idContact}
                idSouhait={this.state.idSouhait}
                onAnnuleFiche={() => this._onCachePanelSouhaitEtRechargementDesDonnees()}
                onEnregistrementFiche={() => this._onCachePanelSouhaitEtRechargementDesDonnees()}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogSuppressionSouhait}
                onDismiss={this._onCacheDialogSuppressionSouhait}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Suppression du souhait',
                    subText: 'Attention, vous êtes en train de supprimer un souhait, souhaitez-vous continuer?'
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={this._onSuppressionSouhait} text="Supprimer" />
                    <DefaultButton onClick={this._onCacheDialogSuppressionSouhait} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;
    }
}